/*
 * Created Date: 20-01-2024, 2:26:16 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Sat Jan 20 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */
import { studioThemeCustomize } from '@App/Studio/app-config/theme'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
const theme = createTheme(studioThemeCustomize('light'))

const MUIThemeProvider = props => {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			{props.children}
		</ThemeProvider>
	)
}

export default MUIThemeProvider
